import React from "react";
import SquareCard from "./common/squreCard";
import {
  faBook,
  faBrain,
  faBriefcase,
  faBuilding,
  faCalculator,
  faComputer,
  faHospital,
  faMicroscope,
  faRuler,
  faScaleBalanced,
  faStethoscope,
  faUserGraduate,
  faWrench,
  faEarthAmericas,
  faLightbulb,
  faTrophy,
  faBullseye,
} from "@fortawesome/free-solid-svg-icons";
import {
  GENERAL_EDUCATION_AWARDS,
  HIGHER_EDUCATION_SPECIALIZATIONS,
} from "../lib/awardConfig";

export const AwardCategories = () => {
  const higherEducationIcons = {
    "Applied Sciences": faMicroscope,
    "Business & Management": faBriefcase,
    Computing: faComputer,
    Education: faUserGraduate,
    Engineering: faWrench,
    "Language and Literature": faBook,
    Law: faScaleBalanced,
    "Mathematics & Statistics": faCalculator,
    Medicine: faHospital,
    "Allied Health Sciences": faStethoscope,
    "Psychology and Counselling": faBrain,
    "Social Sciences": faEarthAmericas,
  };
  const generalEducationIcons = {
    "Impactful Teaching": faLightbulb,
    "Community Engagement": faTrophy,
    "Educational Innovation": faBullseye,
  };

  const categories_he = HIGHER_EDUCATION_SPECIALIZATIONS.map((name) => ({
    name,
    icon: higherEducationIcons[name],
  }));

  const categories_ge = GENERAL_EDUCATION_AWARDS.map((name) => ({
    name,
    icon: generalEducationIcons[name],
  }));
  return (
    <div
      className="flex flex-col justify-center h-full min-h-screen bg-slate-900 category-bg-color py-10 lg:py-20"
      id="categories"
    >
      <div className="text-center relative z-20">
        <h1
          className="text-4xl font-bold sm:text-6xl capitalize tracking-wider text-[#dd7538] my-10 lg:my-0 px-4 lg:px-0 section-title relative mx-auto w-fit"
          style={{ fontFamily: "Bebas Neue" }}
          data-aos="fade-left"
          data-aos-delay="100"
        >
          Award Categories for 2026
        </h1>
      </div>
      <div className="py-0 sm:py-20">
        <div className="text-left relative z-20">
          <h2
            className="text-2xl sm:text-4xl font-bold capitalize tracking-wider text-[#dd7538] my-6 lg:my-0 px-4 lg:px-0 relative w-fit mx-auto"
            style={{ fontFamily: "Bebas Neue" }}
            data-aos="fade-left"
            data-aos-delay="100"
          >
            General Education
          </h2>
        </div>
        <div className="mx-auto flex items-center gap-x-8 gap-y-10 sm:max-w-xl sm:gap-x-10 lg:max-w-7xl flex-wrap justify-center px-4 lg:px-0 mt-4">
          {categories_ge.map((category, index) => (
            <SquareCard data={category} key={index} index={index} />
          ))}
        </div>
        <div className="text-left relative z-20 mt-14">
          <h2
            className="text-2xl font-bold sm:text-4xl capitalize tracking-wider text-[#dd7538] my-6 lg:my-0 px-4 lg:px-0 relative w-fit mx-auto"
            style={{ fontFamily: "Bebas Neue" }}
            data-aos="fade-left"
            data-aos-delay="100"
          >
            Higher Education
          </h2>
        </div>
        <div className="mx-auto flex items-center gap-x-8 gap-y-10 sm:max-w-xl sm:gap-x-10 lg:max-w-7xl flex-wrap justify-center px-4 lg:px-0 mt-4">
          {categories_he.map((category, index) => (
            <SquareCard data={category} key={index} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
};
